import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TGetDirectPaymentsRequestSchema,
  TGetDirectPaymentsResponseSchema,
} from "./getDirectPayments.schema";

export const getDirectPayments = (axios: IAxiosInstance) => {
  return async (params: TGetDirectPaymentsRequestSchema) => {
    const response = await axios.noRetry.get<
      IApiResponse<TGetDirectPaymentsResponseSchema>
    >(`/directPayments`, {
      params,
    });

    return response.data;
  };
};
